// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u-6Ps","label":"styles_label__KEha6"};